import { FormElement } from 'app/containers/types';

export interface ResponseError {
  message: string;
}
export type RequestError = ResponseError;

export type ServiceRequestListItemType = {
  timeStamp: string | null;
  id: string;//Request ID : request id
  propertyId: string | null;
  ticketUpdates: string | null;
  address: string | null;
  userId: string | null;
  serviceProviderId: string | null;
  userType: string | null;
  category: string | null;
  status: string | null;
};

export interface NewServiceRequest {
  propertyId: string | null;
  ticketUpdates: string | null;
  address: string | null;
  userId: string | null;
  serviceProviderId: string | null;
  userType: string | null;
  category: string | null;
  status: string | null;
}

export type NewServiceRequestResponse = {
  timeStamp: string | null;
  id: string;//Request ID : request id
  propertyId: string | null;
  ticketUpdates: string | null;
  address: string | null;
  userId: string | null;
  serviceProviderId: string | null;
  userType: string | null;
  category: string | null;
  status: string | null;
  role: any;
  image: any;
  createdAt: string;
  updatedAt: string;
  message?: string;
};

export type ServiceRequestForm = {
  timeStamp: FormElement;
  id: FormElement;
  propertyId: FormElement;
  ticketUpdates: FormElement;
  address: FormElement;
  userId: FormElement;
  serviceProviderId: FormElement;
  userType: FormElement;
  category: FormElement;
  status: FormElement;
  createdAt: FormElement;
  updatedAt: FormElement;
  blockedUntil: FormElement;
};

export type ServiceRequestStateType = {
  impressionsQuery: {
    skip: number;
    limit: number;
    // q: string;
    // status: string;
    // orderField: string;
    // orderDirection: string;
    requestId: string;
    impressionableId: string;
  };
  postsQuery: {
    page: number;
    limit: number;
    q: string;
    status: string;
    orderField: string;
    orderDirection: string;
    requestId: string;
  };
  query: {
    limit: number;
    page: number;
    distributorId: string;
    userType: string;
    q: string;
    orderField: string;
    orderDirection: string;
    createMin: string;
    createMax: string;
    updateMin: string;
    updateMax: string;
  };
  form: {
    serviceRequest: ServiceRequestForm;
  };
  list: {
    items: Array<ServiceRequestListItemType>;
    meta: {
      totalItems: number;
      itemCount: number;
      itemsPerPage: number;
      totalPages: number;
      currentPage: number;
    };
    links: {
      first: string;
      last: string;
      previous: string;
      next: string;
    };
  };
  loading: boolean;
  error: string;
  links: {
    first: string | null,
    previous: string | null,
    next: string | null,
    last: string | null,
  },
  editModal: boolean;
};

export const ServiceRequestState: ServiceRequestStateType = {
  impressionsQuery: {
    requestId: '',
    skip: 0,
    limit: 10,
    impressionableId: '',
  },
  postsQuery: {
    requestId: '',
    page: 1,
    q: '',
    limit: 10,
    orderDirection: '',
    orderField: '',
    status: '',
  },
  query: {
    userType: '',
    distributorId: '',
    limit: 15,
    page: 1,
    q: '',
    orderField: '',
    orderDirection: '',
    updateMax: '',
    updateMin: '',
    createMax: '',
    createMin: '',
  },
  links: {
    first: '',
    previous: '',
    next: '',
    last: '',
  },
  list: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: '',
      previous: '',
      next: '',
      last: '',
    },
  },
  loading: false,
  form: {
    serviceRequest: {
      timeStamp: { value: '' },
      id: { value: '' },
      propertyId: { value: '' },
      ticketUpdates: { value: '' },
      address: { value: '' },
      userId: { value: '' },
      serviceProviderId: { value: '' },
      userType: { value: '' },
      category: { value: '' },
      status: { value: '' },
      createdAt: { value: '' },
      updatedAt: { value: '' },
      blockedUntil: { value: '' },
    },
  },
  error: '',
  editModal: false,
};

export type ContainerState = ServiceRequestStateType;
